/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetAllocationSource = {
    MORNINGSTAR: 'morningstar',
    MANUAL: 'manual'
} as const;
export type AssetAllocationSource = typeof AssetAllocationSource[keyof typeof AssetAllocationSource];


export function instanceOfAssetAllocationSource(value: any): boolean {
    for (const key in AssetAllocationSource) {
        if (Object.prototype.hasOwnProperty.call(AssetAllocationSource, key)) {
            if (AssetAllocationSource[key as keyof typeof AssetAllocationSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetAllocationSourceFromJSON(json: any): AssetAllocationSource {
    return AssetAllocationSourceFromJSONTyped(json, false);
}

export function AssetAllocationSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAllocationSource {
    return json as AssetAllocationSource;
}

export function AssetAllocationSourceToJSON(value?: AssetAllocationSource | null): any {
    return value as any;
}

export function AssetAllocationSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetAllocationSource {
    return value as AssetAllocationSource;
}

